import { Component, Injectable, Output, EventEmitter, forwardRef } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IPeriodFromTo } from '../../../models/IPeriodFromTo';

@Component({
  selector: 'app-multiple-period-selector',
  templateUrl: './multiple-period-selector.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppMultiplePeriodSelectorComponent),
      multi: true
    }
  ]
})

@Injectable()
export class AppMultiplePeriodSelectorComponent implements ControlValueAccessor {
  private _selectedPeriod: string;
  _fromPeriodValue: Date;
  _toPeriodValue: Date;

  _periodRange: IPeriodFromTo;

  _trigger = false;

  nextMonth: string;
  prevMonth: string;
  isOpen = false;
  minDate: Date;
  maxDate: Date;

  constructor() {
    this.fromPeriodValue = new Date();
    this.toPeriodValue = new Date();
  }

  @Output() changed: EventEmitter<IPeriodFromTo> = new EventEmitter();

  private emitChanges() {
    const event = {
      start: moment(this._fromPeriodValue).format('MMMM-YYYY'),
      end: moment(this._toPeriodValue).format('MMMM-YYYY')
    };
    this.propagateChange(event);
    this.changed.emit(event);
  }

  get fromPeriodValue(): Date {
    return this._fromPeriodValue;
  }

  set fromPeriodValue(value: Date) {
    if (value != null && value !== this._fromPeriodValue) {
        this._fromPeriodValue = value;
        this.minDate = this._fromPeriodValue;
    }
  }

  get toPeriodValue (): Date {
    return this._toPeriodValue;
  }

  set toPeriodValue (value: Date) {
    if (value != null && value !== this._toPeriodValue) {
      this._toPeriodValue = value;
      this.maxDate = this._toPeriodValue;
    }
  }

  writeValue(value: IPeriodFromTo): void {
    if (value != null && value !== this._periodRange) {
      this.fromPeriodValue = moment(value.start, 'MMMM-YYYY').toDate();
      this.toPeriodValue = moment(value.end, 'MMMM-YYYY').toDate();
      this.minDate = this.fromPeriodValue;
      this.maxDate = this.toPeriodValue;
      this.emitChanges();
    }
  }

  propagateChange = (_: any) => {};
  registerOnChange(fn) { this.propagateChange = fn; }
  registerOnTouched(fn: any): void {  }
  setDisabledState?(isDisabled: boolean): void {  }


  dpStartOnShown(event) {
    this.isOpen = true;
    event.setViewMode('month');
    event.monthSelectHandler = (ev) => {
      if (moment(ev.date).month() <= moment(this.maxDate).month()) {
        this.fromPeriodValue = ev.date;
        this.emitChanges();
      }
    };
  }

  dpEndOnShown(event) {
    this.isOpen = true;
    event.setViewMode('month');
    event.monthSelectHandler = (ev) => {
      if (moment(ev.date).month() >= moment(this.minDate).month()) {
        this.toPeriodValue = ev.date;
        this.emitChanges();
      }
    };
  }

  previousMonthClick(): void {
    this.fromPeriodValue = moment(this.fromPeriodValue).add(-1, 'month').toDate();
    this.toPeriodValue = this.fromPeriodValue;
    this.emitChanges();
  }

  nextMonthClick(): void {
      this.toPeriodValue =  moment(this.toPeriodValue).add(1, 'month').toDate();
      this.fromPeriodValue = this.toPeriodValue;
      this.emitChanges();
  }

  toPeriodChanged (event: Date) {
    if (event != null) {
      this.nextMonth = moment(event).add(1, 'month').format('MMMM-YYYY');
    }
  }

  fromPeriodChanged(event: Date) {
    if (event != null) {
        this.prevMonth = moment(event).add(-1, 'month').format('MMMM-YYYY');
    }
  }

}

